import { z } from 'zod';
import { useClientStore } from '@/stores/ClientStore.ts';

const VariableConfigSchema = z.object({
    key: z.string(),
    value: z.union([z.string(), z.array(z.string()), z.undefined()]),
});

const StoreSyncClientValueSchema = z.object({
    streamsWaiting: z.array(z.string()),
    streamStartDates: z.record(z.string(), z.number()),
    sessionVariables: z.record(
        z.string(),
        z.record(
            z.string(),
            z.record(VariableConfigSchema.shape.key, VariableConfigSchema.shape.value),
        ),
    ),
    verticalNavigationOptions: z.record(z.string(), z.record(z.string(), z.boolean())),
    verticalNavigationSelection: z.record(z.string(), z.number()),
    activeSessionId: z.string().optional(),
    activeProfileId: z.string().optional(),
    screenCaptureRevisions: z.record(z.string(), z.number()),
});

export const storeSyncClientHandler = (rawValue: object) => {
    const value = StoreSyncClientValueSchema.parse(rawValue);

    const clientStore = useClientStore();
    clientStore.$patch({
        streamsWaiting: value.streamsWaiting,
        streamStartDates: value.streamStartDates,
        sessionVariables: value.sessionVariables,
        verticalNavigationOptions: value.verticalNavigationOptions,
        verticalNavigationSelection: value.verticalNavigationSelection,
        activeSessionId: value.activeSessionId,
        activeProfileId: value.activeProfileId,
        screenCaptureRevisions: value.screenCaptureRevisions,
    });
};
